import React, {Component} from 'react';

export default class ReasonView extends Component {

    render() {

        let reason = this.props.item;
        if(!reason){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{reason.code}</h3>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Texto</label>
                        <p className={"field-p"}>{reason.text}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Tipo de Viaje</label>
                        <p className={"field-p"}>{reason.trip_type === 'FE' ? 'Fame & Ethanol' : 'Cargas Internas'}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(reason, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ReasonView.js